<template>
  <v-app>
    <eps-login-header></eps-login-header>
    <v-content>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="6" md="6">
            <v-card class="elevation-12">
              <v-toolbar class="app" dark flat>
                <v-toolbar-title>Forgot Password</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
             
              <v-card-text>
                <v-row>
                    <v-col md="10" sm="10">
                        <v-text-field
                            v-model.trim="uid"
                            prepend-icon="email"
                            placeholder="Enter your login id"
                            hint="Enter your login id"
                            clearable
                            :disabled="uid_flag"
                            dense
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col md="2" sm="2">
                        <v-btn class="warning" small :loading="mail_loader" @click="checkId">Proceed</v-btn>
                    </v-col>
                </v-row>
                <template v-if="uid_flag">
                <v-row >
                    <v-col md="8" sm="8">
                        <v-text-field
                            v-model.trim="otp"
                            prepend-icon="mdi-key-link"
                            placeholder="Enter OTP"
                            hint="Enter OTP"
                            dense
                            required
                        ></v-text-field>
                    </v-col>
                   
                    <v-col md="2" sm="2">
                        <v-btn class="warning" small :loading="mail_loader" @click="ResendOTP">Resend OTP</v-btn>
                    </v-col>
                </v-row>
                <v-row >
                    <v-col md="8" sm="8">
                        <v-text-field
                            v-model="password"
                            type="password"
                            prepend-icon="mdi-key"
                            placeholder="Enter password"
                            hint="Enter password"
                            
                            dense
                            required
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row >
                    <v-col md="8" sm="8">
                        <v-text-field
                            v-model="confirm_password"
                            type="password"
                            prepend-icon="mdi-key"
                            placeholder="Re-enter password"
                            hint="Re-enter password"
                            
                            dense
                            required
                        ></v-text-field>
                    </v-col>
                </v-row>
                 <v-row >
                 <v-col md="4" sm="4">
                        <v-btn class="warning" :loading="otp_loader" @click="checkOTP">Change password</v-btn>
                    </v-col>
                 </v-row>
                </template>
              </v-card-text>

              <router-link to="/" style="text-decoration: none" title="Back">
                <v-icon large color="grey darken"
                  >mdi-chevron-left-circle</v-icon
                >
              </router-link>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <eps-login-footer></eps-login-footer>
  </v-app>
</template>

<script>
import axios from "axios";
import epsLoginHeader from "../LoginHeader.vue";
import epsLoginFooter from "../LoginFooter.vue";
export default {
  components: {
    epsLoginHeader: epsLoginHeader,
    epsLoginFooter: epsLoginFooter,
  },
  data() {
    return {
      snackbar_msg: "",
      color: "",
      snackbar: false,
      mail_loader:false,
      otp_loader:false,
      //
      mail_cnt:3,
      uid_flag:false,
      mail_sent_on:null,
      uid:"",  
      confirm_password:"",
      password:"",
      otp:"",

    };
  },
  methods:{
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    async checkId(){
        if(!this.uid){
           this.showSnackbar("error","Please enter uid")
            return 
        }
        if(this.mail_cnt==0){
            this.showSnackbar("error","OTP request exceeded!!!")
            return
        }
        this.mail_loader = true
        this.uid_flag = false
        const formdata={
            uid:this.uid
         }
        try {
            const res = await axios.post("/login/forgetPasswordV2", formdata);
            console.log("result", res.data);
            if (res.data.flag == "YES") {
                this.showSnackbar("success",res.data.snackbar)
                this.uid_flag = true
                this.mail_sent_on = res.data.mail_sent_on
                this.mail_cnt--
            } else {
                this.showSnackbar("error",res.data.snackbar)
                sessionStorage.setItem("error-trace", res.data.error_trace);
            }
        } catch (err) {
            alert("Something went wrong...");
            console.log(err)
        } finally {
            this.mail_loader = false
        }
    },
    async checkOTP(){
        if(this.otp.length==0){
            this.showSnackbar("error","Password enter OTP.") 
           return
        }
        if(this.password.length<4){
           this.showSnackbar("error","Password must be of atleast 4 chanracters.") 
           return
        }
        if(this.password!=this.confirm_password){
             this.showSnackbar("error","Passwords entered mismatched!!!")
             return 
        }
        this.otp_loader = true
        const formdata={
            uid:this.uid,
            otp:this.otp,
            passwrd:this.password,
         }
        try {
            const res = await axios.post("/login/verifyOTPV2", formdata);
            console.log("result", res.data);
            if (res.data.flag == "YES") {
                alert(res.data.snackbar)
                this.$router.push("/");
            } else {
                this.showSnackbar("error",res.data.snackbar)
                sessionStorage.setItem("error-trace", res.data.error_trace);
            }
        } catch (err) {
            alert("Something went wrong...");
            console.log(err)
        } finally {
            this.otp_loader = false
        }
    },
    async ResendOTP(){
        if(this.mail_cnt==0){
            this.showSnackbar("error","OTP request exceeded!!!")
            return
        }
        this.mail_loader = true
        this.uid_flag = false
        const formdata={
            uid:this.uid,
            mail_sent_on:this.mail_sent_on
         }
        try {
            const res = await axios.post("/login/resendOTPV2", formdata);
            console.log("result", res.data);
            if (res.data.flag == "YES") {
                this.showSnackbar("success",res.data.snackbar)
                this.uid_flag = true
                this.mail_cnt--
            } else {
                this.showSnackbar("error",res.data.snackbar)
                sessionStorage.setItem("error-trace", res.data.error_trace);
            }
        } catch (err) {
            alert("Something went wrong...");
            console.log(err)
        } finally {
            this.mail_loader = false
        }
    },
    
  },  
};
</script>
<style scoped>

</style>